import { LocaleEnum as e } from "./locale-enum.mjs";
import { LanguageCodeEnum as t } from "./language-code-enum.mjs";
//#region src/locales/locale-names.ts
var n = {
	[e.ENGLISH]: "English",
	[e.FRENCH]: "Français",
	[e.SPANISH]: "Español",
	[e.ITALIAN]: "Italiano",
	[e.PORTUGUESE]: "Português",
	[e.DEUTSCH]: "Deutsch",
	[e.DUTCH]: "Nederlands",
	[e.RUSSIAN]: "Русский",
	[e.JAPANESE]: "日本語",
	[e.ARABIC]: "العربية",
	[e.TURKISH]: "Türkçe",
	[e.CHINESE]: "中文(简体)",
	[e.SWEDISH]: "Svenska",
	[e.ROMANIAN]: "Română",
	[e.CZECH]: "Čeština",
	[e.HUNGARIAN]: "Magyar",
	[e.SLOVAK]: "Slovenčina",
	[e.DANISH]: "Dansk",
	[e.INDONESIAN]: "Bahasa Indonesia",
	[e.POLISH]: "Polski",
	[e.GREEK]: "Ελληνικά",
	[e.SERBIAN]: "Srpski",
	[e.HINDI]: "हिन्दी",
	[e.NORWEGIAN]: "Norsk",
	[e.THAI]: "ไทย",
	[e.SLOVENIAN]: "Slovenščina",
	[e.UKRAINIAN]: "Українська",
	[e.ALBANIA]: "Shqip"
}, r = {
	[e.ENGLISH]: t.ENGLISH,
	[e.FRENCH]: t.FRENCH,
	[e.SPANISH]: t.SPANISH,
	[e.ITALIAN]: t.ITALIAN,
	[e.PORTUGUESE]: t.PORTUGUESE,
	[e.DEUTSCH]: t.DEUTSCH,
	[e.DUTCH]: t.DUTCH,
	[e.RUSSIAN]: t.RUSSIAN,
	[e.JAPANESE]: t.JAPANESE,
	[e.ARABIC]: t.ARABIC,
	[e.TURKISH]: t.TURKISH,
	[e.CHINESE]: t.CHINESE,
	[e.SWEDISH]: t.SWEDISH,
	[e.ROMANIAN]: t.ROMANIAN,
	[e.CZECH]: t.CZECH,
	[e.HUNGARIAN]: t.HUNGARIAN,
	[e.SLOVAK]: t.SLOVAK,
	[e.DANISH]: t.DANISH,
	[e.INDONESIAN]: t.INDONESIAN,
	[e.POLISH]: t.POLISH,
	[e.GREEK]: t.GREEK,
	[e.SERBIAN]: t.SERBIAN,
	[e.NORWEGIAN]: t.NORWEGIAN,
	[e.THAI]: t.THAI,
	[e.SLOVENIAN]: t.SLOVENIAN,
	[e.UKRAINIAN]: t.UKRAINIAN,
	[e.ALBANIA]: t.ALBANIA,
	[e.HINDI]: t.HINDI
}, i = (e) => r[e];
//#endregion
export { i as getLanguageCodeByLocale, n as localeNames };
